import { API } from 'api';

import { ProvisionalSubmissionResponse } from '../../provisionalSubmissions.types';

export const fetchProvisionalSubmission = async (
  id: number,
): Promise<ProvisionalSubmissionResponse> => {
  const response = await API.get<ProvisionalSubmissionResponse>(
    `provisional_submissions/${id}/`,
  );
  return response.data;
};
